export default __webpack_public_path__ + "static/media/9298.12d2e9b4.svg";